import TableOfContents from "../../../../src/components/table-of-contents";
import * as React from 'react';
export default {
  TableOfContents,
  React
};